import React, { useState } from "react";
import "./index.scss";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { FormikWizard } from "formik-wizard-form";

import { ReactComponent as InfoIcon } from "assets/icons/info2.svg";

import RecipientsMourners from "./RecipientsMourners/RecipientsMourners";
import NonRecipientsMourners from "./NonRecipientsMourners/NonRecipientsMourners";
import Success from "./Success/Success";
import { useDispatch } from "react-redux";
import { setOpenRecipients, setSelectedDeceased } from "../../../commonSlice";

import { toastr } from "react-redux-toastr";


const RecipientsStepper = () => {
  const [finish, setFinish] = useState(false);
  const dispatch = useDispatch();

  const onStepClick = (values, handleNext, setFieldValue, currentStepIndex) => {
    if (currentStepIndex === 2) {
      dispatch(setOpenRecipients(false));
      dispatch(setSelectedDeceased([]));
    }
    handleNext();
  };
  const handleClosePopUp = () => {
    dispatch(setOpenRecipients(false));
  };
  return (
    <div className="recipients__container">
      <FormikWizard
        initialValues={{
          // recipients: [],
          // nonRecipients: [],
          printed: [],
        }}
        onSubmit={(values) => {
          setFinish(true);
        }}
        validateOnNext
        activeStepIndex={0}
        steps={[
          {
            component: RecipientsMourners,
          },
          {
            component: NonRecipientsMourners,
          },
          {
            component: Success,
          },
        ]}
      >
        {({
          currentStepIndex,
          renderComponent,
          handlePrev,
          handleNext,
          isNextDisabled,
          isPrevDisabled,
          values,
          setFieldValue,
        }) => {
          return (
            <>
              <div className="steps__sectoin">
                <Stepper activeStep={currentStepIndex}>
                  <Step completed={currentStepIndex > 0} className="step pl-0">
                    <StepLabel className="step-label">Recipients</StepLabel>
                  </Step>
                  <Step completed={currentStepIndex > 1} className="step">
                    <StepLabel className="step-label">
                      Non Recipients
                      {/* <InfoIcon/> */}
                    </StepLabel>
                  </Step>
                  <Step completed={finish} className="step">
                    <StepLabel className="step-label">Success</StepLabel>
                  </Step>
                </Stepper>
              </div>
              <div className="content__section">{renderComponent()}</div>
              <div className="btns__section">
                {currentStepIndex === 0 ? (
                  <button
                    className="w-100 h-100 d-inline-block d-flex align-items-center justify-content-center"
                    onClick={handleClosePopUp}
                  >
                    Cancel
                  </button>
                ) : (
                  <button onClick={handlePrev} disabled={isPrevDisabled}>
                    Back
                  </button>
                )}

                <button
                  className="btn btn-primary"
                  onClick={() =>
                    onStepClick(
                      values,
                      handleNext,
                      setFieldValue,
                      currentStepIndex
                    )
                  }
                  disabled={isNextDisabled}
                >
                  {currentStepIndex === 0
                    ? "Next: Non-Recipients"
                    : currentStepIndex === 1
                    ? "Finish"
                    : "Done"}
                </button>
              </div>
            </>
          );
        }}
      </FormikWizard>
    </div>
  );
};

export default RecipientsStepper;
